import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAllTacoFoods,
  fetchTacoFoodById,
  fetchTaco4Foods,
  fetchTaco4FoodById,
} from '../actions/nutridataActions';

const nutridataSlice = createSlice({
  name: 'nutridata',
  initialState: {
    tacoFoods: [], // Lista de todos os alimentos Taco      
    currentTacoFood: null, // Alimento Taco atualmente selecionado
    taco4Foods: [],
    currentTaco4Food: null,
    loading: false,        // Estado de carregamento
    error: null,           // Estado de erro
  },
  reducers: {
    setCurrentTacoFood: (state, action) => {
      state.currentTacoFood = action.payload;
    },
    setCurrentTaco4Food: (state, action) => {
      state.currentTaco4Food = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTacoFoods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTacoFoods.fulfilled, (state, action) => {
        state.loading = false;
        state.tacoFoods = action.payload;
      })
      .addCase(fetchAllTacoFoods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTacoFoodById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTacoFoodById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentTacoFood = action.payload;
      })
      .addCase(fetchTacoFoodById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTaco4Foods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaco4Foods.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("Dados recebidos do fetchTaco4Foods:", action.payload);
        state.taco4Foods = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchTaco4Foods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTaco4FoodById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaco4FoodById.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success && action.payload.data.length > 0) {
          state.currentTaco4Food = action.payload.data[0]; // Acessa o primeiro item do array
        } else {
          state.currentTaco4Food = null; // Define como null se não houver dados
        }
      })
      .addCase(fetchTaco4FoodById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setCurrentTacoFood, setCurrentTaco4Food } = nutridataSlice.actions;
export default nutridataSlice.reducer;
